import qs from "qs";

export class UserClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/users`;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async search(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/search${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getByQR(id) {
    const url = `${this.baseURL}/qr/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async putEmail(id, data) {
    const url = `${this.baseURL}/${id}/email`;

    const response = await this.httpClient.request("put", url, {
      data
    });

    return response;
  }

  async putPassword(id, data) {
    const url = `${this.baseURL}/${id}/password`;

    const response = await this.httpClient.request("put", url, {
      data
    });

    return response;
  }

  async putPhoneNumber(id, data) {
    const url = `${this.baseURL}/${id}/mobile_number`;

    const response = await this.httpClient.request("put", url, {
      data
    });

    return response;
  }

  async postCheckin(data) {
    const url = `${this.baseURL}/checkin`;

    const response = this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async invite(id, params) {
    const url = `${this.baseURL}/${id}/invite`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async uninvite(id, params) {
    const url = `${this.baseURL}/${id}/uninvite`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async reverify(params) {
    const url = `${this.baseURL}/reverify`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async postVerify(id, params) {
    const url = `${this.baseURL}/${id}/verify`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async listAdminLogs(id) {
    const url = `${this.baseURL}/${id}/admin_logs`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async deleteUser(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async getTodayReport() {
    const url = `${this.baseURL}/checkin/today`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getEventReport(eventName, date) {
    const url = `${this.baseURL}/checkin/event/${eventName}/${date}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }
}
